import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth = () => {
  console.log('🎯 SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth component loading');
  
  const product = findProductById("amped-32ah-nmc-with-charger");
  
  if (!product) {
    console.error('Product not found:', "amped-32ah-nmc-with-charger");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="amped-32ah-nmc-with-charger"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth; 